import { useState } from 'react'
import { Link2, Copy } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { toast } from 'sonner'
import api from '@/services/api'
import type { Deal } from '@/types'

export function PortalLinkCard({ deal }: { deal: Deal }) {
  const [token, setToken] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const handleGerarToken = async () => {
    setLoading(true)
    try {
      const { data } = await api.post(`/deals/${deal.id}/gerar-token`)
      setToken(data.data.token)
      toast.success('Link do portal gerado!')
    } catch {
      toast.error('Erro ao gerar link do portal')
    } finally {
      setLoading(false)
    }
  }

  const handleCopyLink = () => {
    if (!token) return
    navigator.clipboard.writeText(`${window.location.origin}/portal/${token}`)
    toast.success('Link copiado!')
  }

  return (
    <div className="glass-card p-4 space-y-3">
      <h3 className="text-xs font-bold text-accent uppercase tracking-wider flex items-center gap-2">
        <Link2 size={14} />
        Portal do Cliente
      </h3>
      <p className="text-xs text-text-label">
        Gere um link público para o cliente acompanhar o projeto, responder NPS e ver interações.
      </p>
      {token ? (
        <div className="space-y-2">
          <div className="flex items-center gap-2 p-2 rounded-lg bg-white/[0.04] border border-white/[0.06]">
            <code className="flex-1 text-[11px] text-text-primary truncate">
              {`${window.location.origin}/portal/${token}`}
            </code>
            <button
              onClick={handleCopyLink}
              className="p-1.5 rounded-md text-text-muted hover:text-accent hover:bg-accent/10 transition-colors"
              title="Copiar link"
            >
              <Copy size={13} />
            </button>
          </div>
          <Button variant="ghost" size="sm" onClick={handleGerarToken} loading={loading}>
            Gerar novo token
          </Button>
        </div>
      ) : (
        <Button variant="primary" size="sm" icon={<Link2 size={13} />} loading={loading} onClick={handleGerarToken}>
          Gerar Link do Portal
        </Button>
      )}
    </div>
  )
}
